<template>
  <v-app id="inspire" class="grey lighten-3">
   <UserNavbar/>
   <v-main>
     <v-flex>
         <v-container
        fluid
      >
        <v-layout px-5  row class="mt-1">
          <v-flex xs10 dense>
            <div class="subtitle" style=" font-size: 0.92em;">Dashboard</div>
          </v-flex>
          <v-flex class="text-right" xs2>
            <v-spacer/>
             <v-breadcrumbs class="pa-0" :items="crumbItems" id="crumbs">
              <template v-slot:item="{item}">
                <v-breadcrumbs-item :href="item.href" :disabled="item.disabled" @click="breadCrumbClick(item)" style=" font-size: 0.92em;">
                  {{item.text}}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
        <UserHeader/>
        <DataLake/>
      </v-container>
     </v-flex>
   </v-main>
  </v-app>
</template>

<script>
import UserNavbar from '@/components/UserNavbar'
import UserHeader from '@/components/UserHeader'
import DataLake from '@/components/DataLake'
export default {
  data: () => {
    return {
      crumbItems: [
        {
          text: 'Home',
          disabled: false,
          href: '#',
          route: '/userHome'
        },
        {
          text: 'Data Lake',
          disabled: false,
          href: '#',
          route: '/dataLake'
        }
      ],
      headers: [ { text: 'Report Name', value: 'name' },
        { text: 'Author', value: 'report_by' },
        { text: 'Date Created', value: 'date_created' },
        { text: 'Report Type', value: 'type' }
      ]
    }
  },
  components: {
    UserNavbar,
    UserHeader,
    DataLake
  },
  methods: {
    breadCrumbClick (item) {
      this.$router.push(item.route).catch(() => {
        window.location.reload()
      })
    }
  }
}
</script>

<style scoped>
#crumbs{
  align-content: right;
  justify-content: right;
}
</style>
